'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';
import { ArrowRight, MessageSquareWarning } from 'lucide-react';
import ButtonGAdaptive from '@/components/ButtonGAdaptive';

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
    return (
        <div className="flex flex-shrink-0 justify-start items-start bg-color-light-gray min-w-full h-[calc(100dvh-55px)] lg:h-full pb-3">
            <div className="flex justify-center rounded-md w-full h-full bg-color-white-base/80 shadow-right-bottom">
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="flex flex-col justify-center items-center w-[300px] h-full"
                >
                    <div className="flex justify-start w-full">
                        <div className="flex items-center h-12">
                            <MessageSquareWarning className="text-color-error pr-2" strokeWidth={1.5} size={42} />
                        </div>
                        <div className="flex items-center font-montserrat font-medium text-color-error text-sm">
                            404
                        </div>
                    </div>
                    <div className="flex justify-center items-center font-notojp font-medium text-color-base text-sm w-full">
                        指定されたページは存在しません。 <br />
                        お手数ですがトップページから再度やり直してください。
                    </div>
                    <div className="flex justify-center pt-12">
                        <Link href="/" prefetch={false}>
                            <ButtonGAdaptive
                                type="submit"
                                label="fox.トップページへ"
                                description="fox.top"
                                icon={ArrowRight}
                            />
                        </Link>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
